module.exports = __webpack_public_path__ + "img/taib.f75f234e.png";